import {Title} from '@mantine/core';
import React from 'react';

function ProteinCreationFlowPage(): JSX.Element {
  return <Title>Create proteins</Title>;
}

export default ProteinCreationFlowPage;
